import {remCalc} from '../../_utils'
import accordionStyle from '@salesforce/retail-react-app/app/theme/components/base/accordion'

export default {
    ...accordionStyle,
    baseStyle: {
        ...accordionStyle.baseStyle,
        button: {
            padding: '0',
            height: 'auto',
            _hover: {
                background: 'none',
                cursor: 'initial',
            },
            justifyContent: 'space-between',
            flex: '1 0 0',
            alignItems: {base: 'center', md: 'flex-start'},
        },
        panel: {
            padding: '0',
            marginBottom: '0',
            marginTop: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
        },
        container: {
            padding: remCalc(24),
            borderColor: 'border.light',
        },
        title: {
            color: 'text.default',
            textStyle: ['head-large'],
            padding: {base: `${remCalc(24)} ${remCalc(16)}`, lg: `${remCalc(40)} ${remCalc(260)}`},
            p: ['small.base', 'small.sm', 'xsmall.md', 'medium.lg'],
            paddingInline: {base: `${remCalc(16)}`, lg: `${remCalc(260)}`},
            textAlign: 'center',
            fontWeight: 500,
        },
        item: {
            padding: remCalc(24),
            borderTop: 'none',
            maxW: {base: '100%', md: remCalc(642), lg: remCalc(926)},
            minW: {base: '100%', md: remCalc(474), lg: remCalc(926)},
        },
        accordionStack: {
            width: '100%',
            direction: 'column',
            alignSelf: 'center',
            justifyContent: 'center',
            gap: 0,
            w: '100%',
        },
        accordionStackPaddingBot: {
            paddingTop: ['small.base', 'small.sm', 'medium.md', 'medium.lg'],
            paddingBottom: ['medium.base', 'medium.sm', 'large.md', 'large.lg'],
        },
        accordionContainer: {
            alignSelf: 'center',
            width: '100%',
            spacing: remCalc(8),
        },
        accordionButtonTitle: {
            color: 'text.default',
            fontWeight: '500',
            marginRight: ['small.lg', 'small.lg', 'medium.lg', 'medium.lg'],
        },
        accordionButtonTitleStyle: {textStyle: ['head-small']},
        accordionButtonParagraphStyle: {textStyle: ['head-xsmall']},
        accordionButtonText: {
            textStyle: ['body-medium', 'body-medium', 'body-large', 'body-large'],
            color: 'text.default',
            marginRight: ['0', '0', 'small.lg', 'small.lg'],
        },
        accordionPanelText: {
            textStyle: ['body-medium', 'body-medium', 'body-medium', 'body-large'],
            color: 'text.default',
        },
        accordionPanelTextList: {
            textStyle: ['body-medium'],
            color: 'text.default',
        },
        accordionPanelElement: {
            justifyContent: 'space-between',
            gap: ['small.lg'],
            pb: remCalc(8),
        },
        listItem: {
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            ':last-child': {
                borderBottom: 0,
            },
        },
        iconBox: {
            boxSize: 'iconsSize.large',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        checkIconBox: {
            boxSize: 'iconsSize.medium',
        },
        accordionList: {
            spacing: ['small.lg'],
            marginLeft: 0,
            styleType: 'none',
        },
        mainAccordion: {
            display: 'flex',
            flexDirection: 'column',
            alignSelf: 'center',
            paddingInline: {base: `${remCalc(8)}`, md: '0'},
            width: {base: '100%', md: remCalc(642), lg: remCalc(926)},
        },
    },
    variants: {
        filterAccordion: {
            panel: {
                marginTop: 0,
            },
            container: {
                border: 'none',
                padding: 0,
                marginY: remCalc(11),
            },
        },
    },
    parts: [
        'container',
        'panel',
        'button',
        'title',
        'item',
        'accordionStack',
        'accordionContainer',
        'accordionButtonTitle',
        'accordionButtonText',
        'accordionButtonTextList',
        'accordionPanelElement',
        'iconBox',
        'checkIconBox',
        'accordionList',
        'accordionPanelText',
        'accordionPanelTextList',
        'mainAccordion',
        'listItem',
    ],
}
